import { useMemo } from 'react'

import qs from '@scoir/query-string'

const omitEmpty = (obj: Record<string, string | undefined>) => {
  const result: Record<string, string> = {}
  Object.keys(obj).forEach((key) => {
    const value = obj[key]
    if (value) {
      result[key] = value
    }
  })
  return result
}

const initialHostedRootPath = new RegExp(`^${import.meta.env.BASE_URL}`)

const useBreadcrumbs = (path: string, search: string, label: string) => {
  return useMemo(() => {
    return new URLSearchParams(
      omitEmpty({
        wpLabel: label,
        wpParams: JSON.stringify(qs.parse(search)),
        wpHref: path.replace(initialHostedRootPath, ''),
      }),
    )
  }, [path, search, label])
}

export default useBreadcrumbs
